import React from 'react';

import { ShoppingBagSvg } from '../common/svg';

import '../../styles/common/shopping-bag.scss';

class ShoppingBag extends React.Component {
  componentDidMount() {
    if (window.Snipcart !== undefined) {
      // Would prefer to be able to pass this into the
      // Snipcart plugin, but am having problems defining plugin
      // options as a function.
      const cart = window.Snipcart.store.getState().cart;

      cart.billingAddress.country = "US";
    }
  }

  itemCount () {
    if (typeof window !== 'undefined' && window.Snipcart) {
      const cart = window.Snipcart.store.getState().cart;

      const itemCount = cart.items.items.reduce((acc, val) => {
        return acc + val.quantity;
      }, 0);

      if (itemCount > 0) {
        return itemCount;
      } else {
        return null;
      }
    }
    return null;
  }

  render() {
    return (
      <div className="shopping-bag">
        <button
          aria-label="Shop Checkout"
          className="snipcart-checkout"
        >
          { ShoppingBagSvg }
          <span className="contents-count snipcart-items-count">
            {this.itemCount()}
          </span>
        </button>
      </div>
    );
  }
}

export default ShoppingBag;
